import { getColor } from '../../Loading/utils/loadingHelpers';

export const getIconColor = (theme, colorKey) => {
  return getColor(theme, colorKey);
};

export const getIconSize = (size) => {
  switch (size) {
    case 'xs': return '0.75rem';
    case 'sm': return '1rem';
    case 'lg': return '2rem';
    case 'xl': return '3rem';
    case 'md':
    default:
      return '1.5rem';
  }
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Icon/utils/iconHelpers.js